<template>
  <div :class="['columnsTextImage', { 'columnsTextImage--revert': false }]">
    <div class="columnsTextImage__inner">
      <div v-if="data.Content" class="columnsTextImage__col columnsTextImage__content">
        <cms-wysiwyg :html="data.Content" additional-classes="wysiwyg--bigText" />
      </div>
      <div v-if="data.Image" class="columnsTextImage__col columnsTextImage__image">
        <new-image-box
          :src="JSON.parse(data.Image).url"
          :width="JSON.parse(data.Image).width"
          :height="JSON.parse(data.Image).height"
          :max-width="700"
          center-image
          image-params="w_700,h_500"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CmsWysiwyg from '@/components/Cms/CmsWysiwyg';
import NewImageBox from '@/components/NewImageBox';
export default {
  name: 'ColumnsTextImage',
  components: { NewImageBox, CmsWysiwyg },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.columnsTextImage {
  $root: &;

  &__inner {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 -2rem;
  }

  &__col {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 2rem;

    @include rwd('tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__image {
    @include rwd('tablet') {
      margin-top: 3rem;
    }
  }

  &--revert {
    #{$root}__inner {
      flex-direction: row-reverse;
    }
  }
}
</style>
